module.exports = __webpack_public_path__ + "img/work2021multivision.bbce5edd.jpg";